module.exports = __webpack_public_path__ + "static/media/iosh-logo-charcoal.b72041a3.svg";